import {EmpresaTabs} from '../constants';

export function getTabByName(name) {
  return EmpresaTabs.find(tab => tab.name === name);
}
